classifier.filter('classifiersScheme', () => {
    "use strict";
    return (additionalClassifications, schemes) => {
        let dkSchems = new Set(schemes);
        return (additionalClassifications || []).filter((cl) => {
            return dkSchems.has(cl.scheme);
        });
    }
});